import { push } from 'redux-first-history';
import Bowser from 'bowser';

import { httpPost, httpDelete } from 'utils';
import { openPageLoading, closePageLoading } from 'containers/App/actions/ui';

export function showCompanySettings(id) {
  return (dispatch) => {
    dispatch(push(`/admin/company/${id}/settings`));
  };
}

export function showCompanyUsers(id) {
  return (dispatch) => {
    dispatch(push(`/admin/company/${id}/users`));
  };
}

export function impersonate({ userId, companyId, targetPath }) {
  return (dispatch) => {
    dispatch(openPageLoading());

    const payload = {
      user_id: userId,
      company_id: companyId,
    };

    httpPost('/impersonate', payload)
      .then((response) => {
        const { jwt, exp, admin_membership_id: adminMembershipId } = response;

        localStorage.setItem('phoenixAuthToken', jwt);
        localStorage.setItem('phoenixExpToken', exp);
        localStorage.setItem('adminMembershipId', adminMembershipId);
        sessionStorage.removeItem('cachedSession');

        dispatch({
          type: 'SET_ADMIN_MEMBERSHIP_ID',
          adminMembershipId,
        });

        document.location.href = targetPath || '/';
      })

      /* eslint no-unused-vars:0 */
      .catch(() => {
        dispatch(closePageLoading());
      });
  };
}

export function unimpersonate({ password }) {
  return (dispatch) => {
    dispatch(openPageLoading());

    const payload = { password };

    httpDelete('/impersonate', payload)
      .then((response) => {
        const { jwt, exp } = response;

        localStorage.setItem('phoenixAuthToken', jwt);
        localStorage.setItem('phoenixExpToken', exp);
        localStorage.removeItem('adminMembershipId');
        sessionStorage.removeItem('cachedSession');

        dispatch({
          type: 'DELETE_ADMIN_MEMBERSHIP_ID',
        });

        document.location.href = '/admin';
      })

      .catch(() => {
        dispatch(closePageLoading());
      });
  };
}

export function logImpersonation(
  impersonatedUserId,
  impersonatedCompanyId,
  impersonationReason
) {
  return () => {
    const {
      parsedResult: {
        browser: { name: browserName, version: browserVersion },
        os: { name: OSName, version: OSVersion, versionName: OSVersionName },
        platform: { type: platformType },
        engine: { name: engineName, version: engineVersion },
      },
    } = Bowser.getParser(window.navigator.userAgent);

    const payload = {
      user_id: impersonatedUserId,
      company_id: impersonatedCompanyId,
      message: impersonationReason,
      user_agent: {
        browser_version: `${browserName} ${browserVersion}`,
        os_version: `${OSName} ${OSVersionName}, ${OSVersion}`,
        platform: `${platformType}`,
        engine: `${engineName} ${engineVersion}`,
      },
    };

    return httpPost('/impersonate/log', payload);
  };
}
